import { css } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';
import React from 'react';
import { OutlookIcon } from '../../icons';

type GoogleButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text?: string;
  disabled?: boolean;
  width?: string;
};

export const MicrosoftButton: React.FC<GoogleButtonProps> = ({
  onClick,
  text = 'Login',
  disabled = false,
  width = '100%',
}) => {
  if (disabled) {
    return (
      <button
        className={css`
          border-radius: 76px;
          background: #4C4A4A;
          max-width: 340px;
          width: ${width};
          height: 48px;
          cursor: not-allowed;
          color: #969696;
          opacity: 1;
          font-family: ${theme.font.button.fontFamily};
          font-size: ${theme.font.button.fontSize};
          font-style: normal;
          font-weight: 900;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 24px;
          @media (max-width: 700px) {
            padding: 0 16px;
          }
        `}
      >
        Coming Soon
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className={css`
        border-radius: 76px;
        background: ${theme.colors.text.primary};
        max-width: 340px;
        width: ${width};
        height: 48px;
        cursor: ${disabled ? 'not-allowed' : 'pointer'};
        color: ${theme.colors.text.dark};
        opacity: ${disabled ? 0.5 : 1};
        font-family: ${theme.font.button.fontFamily};
        font-size: ${theme.font.button.fontSize};
        font-style: normal;
        font-weight: 900;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 24px;
        @media (max-width: 700px) {
          padding: 0 16px;
        }
      `}
    >
      <OutlookIcon
        style={{ width: '28px', height: '26px', marginRight: '16px' }}
      />
      {text}
    </button>
  );
};
